const ProductTileContainerSx = {
  display: "flex"
};
const ProductTileContainerSkeletonSx = {
  maxWidth: "100%"
};
const CarouselContainer = {
  maxWidth: 1400,
  width: "100%"
};
export {
  CarouselContainer,
  ProductTileContainerSkeletonSx,
  ProductTileContainerSx
};
